import { useLocation } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function InstagramButton() {
  const loc = useLocation();

  // Hide button on full-screen event invites, galleries, admin portal, or AR route
  if (
    loc.pathname.startsWith("/invite") ||
    loc.pathname.startsWith("/photos") ||
    loc.pathname.startsWith("/admin") ||
    loc.pathname.startsWith("/ar")
  ) {
    return null;
  }

  const igLink = "https://instagram.com/KV_EVENTECH";

  return (
    <a
      href={igLink}
      target="_blank"
      rel="noreferrer"
      className="fixed top-[44%] md:top-auto bottom-auto md:bottom-[6.5rem] right-3 md:right-8 z-[99] flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] rounded-full text-white shadow-[0_8px_30px_rgba(0,0,0,0.4)] hover:shadow-[0_8px_30px_rgba(221,42,123,0.4)] transition-all duration-300 hover:scale-110 group cursor-pointer"
      aria-label="Follow us on Instagram"
    >
      {/* Tooltip */}
      <span className="absolute right-14 md:right-16 px-4 py-2 text-[10px] uppercase tracking-[0.2em] font-display bg-ink/95 border border-line text-parchment rounded-md opacity-0 scale-95 origin-right group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 pointer-events-none whitespace-nowrap shadow-xl">
        Follow on Instagram
      </span>
      {/* Lucide Instagram Icon */}
      <Instagram className="w-5 h-5 md:w-6 md:h-6 stroke-[1.75]" />
    </a>
  );
}
